<template>
  <div id="bubble">
    {{ value }}
  </div>
</template>

<script>
export default {
  props: ['value']
}
</script>

<style scoped lang="scss">
#bubble {
  padding: 5px 10px 5px 10px;
  margin-right: 10px;
  background: #348AA7;
  font-weight: 300;
  color: white;
  display: inline-flex;
  width: auto;
  margin-bottom: 0.5em;
  border-radius: 100px;
}
</style>
